/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayAccountSetup
 */
export interface AdminEbayAccountSetup {
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    fulfillmentPolicyId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEbayAccountSetup
     */
    handlingTimeDays: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    merchantLocationKey: string;
    /**
     * OrdersSyncedAt: eBay orders modified before it are imported; null before the first import.
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    ordersSyncedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    paymentPolicyId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    returnPolicyId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    setUpAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountSetup
     */
    shipFromPostalCode: string;
}

export function AdminEbayAccountSetupFromJSON(json: any): AdminEbayAccountSetup {
    return AdminEbayAccountSetupFromJSONTyped(json, false);
}

export function AdminEbayAccountSetupFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayAccountSetup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fulfillmentPolicyId': json['fulfillmentPolicyId'],
        'handlingTimeDays': json['handlingTimeDays'],
        'merchantLocationKey': json['merchantLocationKey'],
        'ordersSyncedAt': !exists(json, 'ordersSyncedAt') ? undefined : json['ordersSyncedAt'],
        'paymentPolicyId': json['paymentPolicyId'],
        'returnPolicyId': json['returnPolicyId'],
        'setUpAt': json['setUpAt'],
        'shipFromPostalCode': json['shipFromPostalCode'],
    };
}

export function AdminEbayAccountSetupToJSON(value?: AdminEbayAccountSetup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fulfillmentPolicyId': value.fulfillmentPolicyId,
        'handlingTimeDays': value.handlingTimeDays,
        'merchantLocationKey': value.merchantLocationKey,
        'ordersSyncedAt': value.ordersSyncedAt,
        'paymentPolicyId': value.paymentPolicyId,
        'returnPolicyId': value.returnPolicyId,
        'setUpAt': value.setUpAt,
        'shipFromPostalCode': value.shipFromPostalCode,
    };
}

